import React, { Component } from 'react'

import Hero from './Sections/Hero'
import Background from './Sections/Background'
import Introduction from './Sections/Introduction'
import Services from './Sections/Services'
import VerticalSeparator from '../../general/Decorations/VerticalSeparator'
import Featured from './Sections/Featured'
import Navbar from '../../general/Navbar'
import Footer from '../../general/Footer'
import './style.css'

export default class Home extends Component {

  componentDidMount() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  render() {
    return (
      <div className="w-100 mw-100 flex flex-column">
        <Navbar />
        <Background/>
        <Hero/>
        <Introduction/>
        <VerticalSeparator/>
        <Services/>
        <Featured/>
        <Footer />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/index.jsx